export const globalSet = `
... on bright_GlobalSet {
  id
  name
  brightContact {
    slug
    title
    id
  }
  brightPromises {
    id
    slug
    typeHandle
    ... on brightPromise_brightPromise_Entry {
      id
      title
      color
    }
    ... on brightPromiseInteractif_brightPromiseInteractif_Entry {
      id
      title
      color
      promiseTitle
      brightCaseStudy {
        id
        ... on brightCaseStudy_brightCaseStudy_Entry {
          id
          title
          slug
          brightYear
          brightClient
          brightPlateform
          description
          image {
            id
            url
          }
        }
      }
    }
  }
  brightTestimonials {
    ... on brightTestimonials_testimonial_BlockType {
      id
      fullName
      role
      picture {
        id
        url
      }
      text
    }
  }
  brightMenu {
    ... on brightMenu_item_BlockType {
      id
      titre
      href
      links {
        href
        title
      }
      previews {
        id
        url
      }
    }
  }
}`